"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NaniumProviderBrowser = exports.NaniumBrowserProviderConfig = void 0;
const eventSubscription_1 = require("../../interfaces/eventSubscription");
const objects_1 = require("../../objects");
class NaniumBrowserProviderConfig {
}
exports.NaniumBrowserProviderConfig = NaniumBrowserProviderConfig;
class NaniumProviderBrowser {
    // private eventSubscriptions: { [clientId: string]: ProviderEventSubscriptionInfo } = {};
    constructor(config) {
        this.internalEventSubscriptions = {};
        this.config = {
            isResponsible: async () => Promise.resolve(1),
            isResponsibleForEvent: async () => Promise.resolve(1),
            handleError: async (err) => {
                throw err;
            }
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.repository = {};
    }
    addService(requestClass, executorClass) {
        this.repository[requestClass.serviceName] = {
            Executor: executorClass,
            Request: requestClass
        };
    }
    addChannel(channel) {
        throw ('channels not supported by this provider');
    }
    getRequestClass(serviceName) {
        var _a;
        return (_a = this.repository[serviceName]) === null || _a === void 0 ? void 0 : _a.Request;
    }
    async init() {
    }
    async terminate() {
    }
    async isResponsible(request, serviceName) {
        return await this.config.isResponsible(request, serviceName);
    }
    async execute(serviceName, request, context) {
        var _a;
        context = context || {};
        try {
            // validation
            if (this.repository === undefined) {
                return await this.config.handleError(new Error('nanium server is not initialized'), serviceName, request, context);
            }
            if (!this.repository.hasOwnProperty(serviceName)) {
                return await this.config.handleError(new Error('unknown service ' + serviceName), serviceName, request, context);
            }
            const requestConstructor = this.repository[serviceName].Request;
            if ((context === null || context === void 0 ? void 0 : context.scope) === 'public') { // private is the default, all adaptors have to set the scope explicitly
                if (!requestConstructor.scope || requestConstructor.scope !== 'public') {
                    return await this.config.handleError(new Error('unauthorized'), serviceName, request, context);
                }
            }
            if (request.constructor !== requestConstructor) {
                request = objects_1.NaniumObject.create(request, requestConstructor);
            }
            // interceptors
            if ((_a = this.config.requestInterceptors) === null || _a === void 0 ? void 0 : _a.length) {
                let result;
                for (const interceptor of this.config.requestInterceptors) {
                    result = await (typeof interceptor === 'function' ? new interceptor() : interceptor).execute(request, context);
                    // if an interceptor returns an object other than the request it is a result and the execution shall be
                    // finished with this result
                    if (result !== undefined && result !== request) {
                        return result;
                    }
                }
            }
            // execution
            const executor = new this.repository[serviceName].Executor();
            return await executor.execute(request, context);
        }
        catch (e) {
            return await this.config.handleError(e, serviceName, request, context);
        }
    }
    async emit(eventName, event, executionContext) {
        var _a;
        if ((_a = this.internalEventSubscriptions[eventName]) === null || _a === void 0 ? void 0 : _a.length) {
            for (const s of this.internalEventSubscriptions[eventName]) {
                s.handler(event);
            }
        }
    }
    async isResponsibleForEvent(eventName, context) {
        return await this.config.isResponsibleForEvent(eventName, context);
    }
    async subscribe(eventConstructor, handler, context) {
        var _a;
        const eventName = typeof eventConstructor === 'string' ? eventConstructor : eventConstructor.eventName;
        const subscription = new eventSubscription_1.EventSubscription('', eventName, handler);
        subscription.context = context;
        this.internalEventSubscriptions[eventName] = (_a = this.internalEventSubscriptions[eventName]) !== null && _a !== void 0 ? _a : [];
        this.internalEventSubscriptions[eventName].push(subscription);
        return subscription;
    }
    async unsubscribe(subscription, eventName) {
        var _a;
        eventName = (_a = subscription === null || subscription === void 0 ? void 0 : subscription.eventName) !== null && _a !== void 0 ? _a : eventName;
        if (subscription) {
            if (eventName in this.internalEventSubscriptions) {
                this.internalEventSubscriptions[eventName] = this.internalEventSubscriptions[eventName]
                    .filter(s => s !== subscription);
            }
        }
        else {
            delete this.internalEventSubscriptions[eventName];
        }
    }
    async removeClient(_clientId) {
    }
    async receiveSubscription(subscriptionData) {
    }
}
exports.NaniumProviderBrowser = NaniumProviderBrowser;
//# sourceMappingURL=browser.js.map